// Constrain the (otherwise very wide) "large" modal to a comfortable fixed
// width with its own padding, matching the CRM message-creators modal so the
// composer doesn't float in a sparse box.
// eslint-disable-next-line import/prefer-default-export
export const BULK_MESSAGE_MODAL_SX = {
  '& .MuiPaper-root': {
    width: '600px',
    maxWidth: '90vw',
    borderRadius: '32px',
    padding: '48px 40px 40px',
  },
};
